import { BUSCAR_TOMADORES } from '../../actions/types';
import { DETERMINAR_PAGINA_ATUAL_TOMADORES } from '../../actions/types';
import { ALTERAR_REGISTROS_POR_PAGINA_TOMADORES } from '../../actions/types';


const initialState = {
  tomadores: [],
  paginaAtualTomadores: 1,
  registrosPorPaginaTomadores: 10,
  total: 0
}

export default function reducerTomador (state = initialState, action) {
  switch (action.type) {
    case BUSCAR_TOMADORES: {
      const {tomadoresDto, totalRegistros} = action.payload.data;
      if (tomadoresDto) {
        return {
          ...state,
          tomadores: tomadoresDto,
          total: totalRegistros
        }
      }
      return []
    }

    case DETERMINAR_PAGINA_ATUAL_TOMADORES: {
      return {
        ...state,
        paginaAtualTomadores: action.payload
      };
    }

    case ALTERAR_REGISTROS_POR_PAGINA_TOMADORES: {
      return {
        ...state,
        registrosPorPaginaTomadores: action.payload
      };
    }

    default: {
      return state
    }
  }
}

